module.exports = __webpack_public_path__ + "img/VISA QR1.572ca6de.svg";